module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-popup vedio-popup",
    staticStyle: {
      "position": "fixed",
      "top": "0",
      "left": "0",
      "width": "100%",
      "height": "100%",
      "background": "rgba(0,0,0,.2)",
      "z-index": "9001"
    },
    attrs: {
      "id": "myVideo"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [_c('table', {
    staticStyle: {
      "table-layout": "fixed",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('tr', [_c('td', [_c('div', {
    staticClass: "wrapper",
    staticStyle: {
      "width": "722px",
      "border-radius": "0",
      "position": "relative",
      "margin": "0 auto",
      "background": "#fff",
      "box-shadow": "0 2px 10px rgba(0,0,0,0.2)"
    }
  }, [_c('div', {
    staticClass: "header f-ff0",
    staticStyle: {
      "border": "none",
      "line-height": "60px",
      "height": "60px",
      "padding": "0 24px",
      "border-bottom": "1px solid #e8e8e8"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px",
      "font-weight": "bolder",
      "color": "#333"
    },
    attrs: {
      "id": "videoTitle"
    }
  }), _vm._v(" "), _c('a', {
    staticStyle: {
      "float": "right",
      "display": "inline-block",
      "width": "18px",
      "height": "18px",
      "background": "url('https://image.izhaowo.com/www2/images/x.png')",
      "margin-top": "20px"
    },
    attrs: {
      "href": "javascript:void(0);",
      "title": "关闭"
    },
    on: {
      "click": _vm.closeVideo
    }
  })]), _vm._v(" "), _vm._m(0)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content f-ff0",
    staticStyle: {
      "min-height": "100px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "722px",
      "height": "455px",
      "background": "#eee"
    },
    attrs: {
      "id": "youkuplayer"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55922f1a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/openVideo.vue
// module id = 236
// module chunks = 2 3